// extracted by mini-css-extract-plugin
module.exports = {"sticky":"Sticky_sticky__Xn9hi","onlyViewSelector":"Sticky_onlyViewSelector__s0xkd"};